import { domScheduler } from "@studiometa/js-toolkit/utils";
import { fallbackStore as store } from "../utils/storage/index.js";
const key = "header";
const headerVisibilities = /* @__PURE__ */ new Set(["visible", "hidden"]);
const defaultHeaderVisibility = "visible";
async function getHeaderVisibility() {
  return await store.get(key) || defaultHeaderVisibility;
}
async function headerIs(position) {
  return await getHeaderVisibility() === position;
}
async function headerIsVisible() {
  return headerIs("visible");
}
async function headerIsHidden() {
  return headerIs("hidden");
}
async function headerUpdateDOM(value) {
  const header = value ?? await getHeaderVisibility();
  domScheduler.write(() => {
    document.documentElement.classList.toggle("has-header", header === "visible");
  });
}
async function setHeaderVisibility(value) {
  let header = value ?? await getHeaderVisibility();
  if (!headerVisibilities.has(header)) {
    console.warn(`The "${header}" header visibility is not valid.`);
    header = defaultHeaderVisibility;
  }
  await Promise.all([store.set(key, header), headerUpdateDOM(header)]);
}
function watchHeaderVisibility(callback) {
  return store.watch((k, newValue) => k === key && callback(newValue));
}
export {
  getHeaderVisibility,
  headerIs,
  headerIsHidden,
  headerIsVisible,
  headerUpdateDOM,
  setHeaderVisibility,
  watchHeaderVisibility
};
//# sourceMappingURL=header.js.map
